import { render, staticRenderFns } from "./SapComponent.vue?vue&type=template&id=1c4acdfc&"
import script from "./SapComponent.vue?vue&type=script&lang=js&"
export * from "./SapComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports